import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Poppins', sans-serif;
    line-height: 1.6;
    color: #333;
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
    margin-bottom: 1rem;
  }

  h1 {
    font-size: 2.5rem;
    color: #dc2626;
  }

  h2 {
    font-size: 2rem;
    color: #dc2626;
  }

  h3 {
    font-size: 1.5rem;
  }

  p {
    margin-bottom: 1rem;
    line-height: 1.8;
  }

  a {
    color: #dc2626;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: #b91c1c;
    }
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
  }

  .btn {
    display: inline-block;
    padding: 12px 30px;
    background: #dc2626;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    transition: all 0.3s ease;
    text-transform: uppercase;
    letter-spacing: 1px;

    &:hover {
      background: #b91c1c;
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(220, 38, 38, 0.3);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .btn-outline {
    background: transparent;
    border: 2px solid #dc2626;
    color: #dc2626;

    &:hover {
      background: #dc2626;
      color: white;
    }
  }

  .section {
    padding: 80px 0;
  }

  .section-title {
    text-align: center;
    margin-bottom: 3rem;
    
    h2 {
      font-size: 2.5rem;
      margin-bottom: 1rem;
    }
    
    p {
      font-size: 1.1rem;
      color: #666;
      max-width: 600px;
      margin: 0 auto;
    }
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 2rem;
    }

    h2 {
      font-size: 1.5rem;
    }

    .section {
      padding: 50px 0;
    }

    .section-title h2 {
      font-size: 2rem;
    }
  }
`;

export default GlobalStyles;
